import * as React from 'react'

import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { employeesApi } from '../../api'
import { Container, Section } from '../../ui-kit'
import { statisticsDomain, statisticsOverviewPath } from '../../../config'

import { employeeStore } from '../../../end-user/EmployeeStore'

export const PageStatistics = observer((props: { page?: string }) => {
  const { page } = props
  const [statisticsUrl, setStatisticsUrl] = useState('')

  useEffect(() => {
    employeesApi.getGamification(employeeStore.employee?.id.toUpperCase()!).then(res => {
      setStatisticsUrl(`${statisticsDomain}/${page ?? statisticsOverviewPath}?${res.data}`)
    })
  }, [])

  return (
    <main id="main" className="page-special-offer">
      <Section size="xxlarge">
        <Container>
          {statisticsUrl && (
            <iframe
              width="100%"
              style={{ border: 0, flex: 1 }}
              height="1300px"
              src={statisticsUrl}
              title="statistics"
            />
          )}
        </Container>
      </Section>
    </main>
  )
})
